type Images = {
  //   key: string;
  //   originalHeight: number;
  //   originalWidth: number;
  thumbnailHeight: number;
  thumbnailWidth: number;
  original: string;
  thumbnail?: string;
  originalTitle: string;
};

export const images: Images[] = [
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_1.jpg",
    thumbnail: "../../../photo_1.jpg",
    originalTitle: "ГЦОУД 3'В,Б' - 03.11.2023 Ден на българския художник",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_2.jpg",
    thumbnail: "../../../photo_2.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_3.jpg",
    thumbnail: "../../../photo_3.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_4.jpg",
    thumbnail: "../../../photo_4.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_5.jpg",
    thumbnail: "../../../photo_5.jpg",
    originalTitle: "11.01.2023г. Световен ден на думата Благодаря",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_6.jpg",
    thumbnail: "../../../photo_6.jpg",
    originalTitle: "11.01.2023г. Световен ден на думата Благодаря",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_7.jpg",
    thumbnail: "../../../photo_7.jpg",
    originalTitle: "Световен ден на Земята",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_8.jpg",
    thumbnail: "../../../photo_8.jpg",
    originalTitle: "Световен ден на Земята",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_9.jpg",
    thumbnail: "../../../photo_9.jpg",
    originalTitle: "14.12.2023г.Бабо разкажи ми приказка",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_10.jpg",
    thumbnail: "../../../photo_10.jpg",
    originalTitle: "Коледна работилничка",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_11.jpg",
    thumbnail: "../../../photo_11.jpg",
    originalTitle: "Коледна работилничка",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_12.jpg",
    thumbnail: "../../../photo_12.jpg",
    originalTitle: "ГЦОУД 2“В“",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_13.jpg",
    thumbnail: "../../../photo_13.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_14.jpg",
    thumbnail: "../../../photo_14.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_15.jpg",
    thumbnail: "../../../photo_15.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_16.jpg",
    thumbnail: "../../../photo_16.jpg",
    originalTitle: "ГЦОУД 4.'В,Б'",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_17.jpg",
    thumbnail: "../../../photo_17.jpg",
    originalTitle: "01.11.2023г. Ден на народните будители",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_18.jpg",
    thumbnail: "../../../photo_18.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_19.jpg",
    thumbnail: "../../../photo_19.jpg",
    originalTitle: "tolerant",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_20.jpg",
    thumbnail: "../../../photo_20.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_21.jpg",
    thumbnail: "../../../photo_21.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_22.jpg",
    thumbnail: "../../../photo_22.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_23.jpg",
    thumbnail: "../../../photo_23.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_24.jpg",
    thumbnail: "../../../photo_24.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_25.jpg",
    thumbnail: "../../../photo_25.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_26.jpg",
    thumbnail: "../../../photo_26.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_27.jpg",
    thumbnail: "../../../photo_27.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_28.jpg",
    thumbnail: "../../../photo_28.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_29.jpg",
    thumbnail: "../../../photo_29.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_30.jpg",
    thumbnail: "../../../photo_30.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_31.jpg",
    thumbnail: "../../../photo_31.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_32.jpg",
    thumbnail: "../../../photo_32.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_33.jpg",
    thumbnail: "../../../photo_33.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_34.jpg",
    thumbnail: "../../../photo_34.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_35.jpg",
    thumbnail: "../../../photo_35.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_36.jpg",
    thumbnail: "../../../photo_36.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_37.jpg",
    thumbnail: "../../../photo_37.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_38.jpg",
    thumbnail: "../../../photo_38.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_39.jpg",
    thumbnail: "../../../photo_39.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_40.jpg",
    thumbnail: "../../../photo_40.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_41.jpg",
    thumbnail: "../../../photo_41.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_42.jpg",
    thumbnail: "../../../photo_42.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_43.jpg",
    thumbnail: "../../../photo_43.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_44.jpg",
    thumbnail: "../../../photo_44.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_45.jpg",
    thumbnail: "../../../photo_45.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_46.jpg",
    thumbnail: "../../../photo_46.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_47.jpg",
    thumbnail: "../../../photo_47.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_48.jpg",
    thumbnail: "../../../photo_48.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_49.jpg",
    thumbnail: "../../../photo_49.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_50.jpg",
    thumbnail: "../../../photo_50.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_51.jpg",
    thumbnail: "../../../photo_51.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_52.jpg",
    thumbnail: "../../../photo_52.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_53.jpg",
    thumbnail: "../../../photo_53.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_54.jpg",
    thumbnail: "../../../photo_54.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_55.jpg",
    thumbnail: "../../../photo_55.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_56.jpg",
    thumbnail: "../../../photo_56.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_57.jpg",
    thumbnail: "../../../photo_57.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_58.jpg",
    thumbnail: "../../../photo_58.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_59.jpg",
    thumbnail: "../../../photo_59.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_60.jpg",
    thumbnail: "../../../photo_60.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_61.jpg",
    thumbnail: "../../../photo_61.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_62.jpg",
    thumbnail: "../../../photo_62.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_63.jpg",
    thumbnail: "../../../photo_63.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_64.jpg",
    thumbnail: "../../../photo_64.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_65.jpg",
    thumbnail: "../../../photo_65.jpg",
    originalTitle:
      "ГЦОУД 2.г клас - 'Ние ще пазим Земята!'- 100 начина да спасим Земята",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_66.jpg",
    thumbnail: "../../../photo_66.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_67.jpg",
    thumbnail: "../../../photo_67.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_68.jpg",
    thumbnail: "../../../photo_68.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_69.jpg",
    thumbnail: "../../../photo_69.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_70.jpg",
    thumbnail: "../../../photo_70.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_71.jpg",
    thumbnail: "../../../photo_71.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_72.jpg",
    thumbnail: "../../../photo_72.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_73.jpg",
    thumbnail: "../../../photo_73.jpg",
    originalTitle: "01.06.2026г. Ден на детето - 2026",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_74.jpg",
    thumbnail: "../../../photo_74.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_75.jpg",
    thumbnail: "../../../photo_75.jpg",
    originalTitle: "24.05.2026г",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_76.jpg",
    thumbnail: "../../../photo_76.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_77.jpg",
    thumbnail: "../../../photo_77.jpg",
    originalTitle: "16.05.2026г. – Празник на шоколада",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_78.jpg",
    thumbnail: "../../../photo_78.jpg",
    originalTitle: "25.03.2026г. Ден на търпението и Благовещение",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_79.jpg",
    thumbnail: "../../../photo_79.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_80.jpg",
    thumbnail: "../../../photo_80.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_81.jpg",
    thumbnail: "../../../photo_81.jpg",
    originalTitle: "12.01.2026г- Бабо разкажи ми приказка",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_82.jpg",
    thumbnail: "../../../photo_82.jpg",
    originalTitle: "11.01.2026г.Световен ден на думата Благодаря – открит урок",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_83.jpg",
    thumbnail: "../../../photo_83.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_84.jpg",
    thumbnail: "../../../photo_84.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_85.jpg",
    thumbnail: "../../../photo_85.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_86.jpg",
    thumbnail: "../../../photo_86.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_87.jpg",
    thumbnail: "../../../photo_87.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_88.jpg",
    thumbnail: "../../../photo_88.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_89.jpg",
    thumbnail: "../../../photo_89.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_90.jpg",
    thumbnail: "../../../photo_90.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_91.jpg",
    thumbnail: "../../../photo_91.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_92.jpg",
    thumbnail: "../../../photo_92.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_93.jpg",
    thumbnail: "../../../photo_93.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_94.jpg",
    thumbnail: "../../../photo_94.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_95.jpg",
    thumbnail: "../../../photo_95.jpg",
    originalTitle: "21.11.25г.",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_96.jpg",
    thumbnail: "../../../photo_96.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_97.jpg",
    thumbnail: "../../../photo_97.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_98.jpg",
    thumbnail: "../../../photo_98.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_99.jpg",
    thumbnail: "../../../photo_99.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_100.jpg",
    thumbnail: "../../../photo_100.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_101.jpg",
    thumbnail: "../../../photo_101.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_102.jpg",
    thumbnail: "../../../photo_102.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_103.jpg",
    thumbnail: "../../../photo_103.jpg",
    originalTitle: "Седмица на спорта",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_104.jpg",
    thumbnail: "../../../photo_104.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_105.jpg",
    thumbnail: "../../../photo_105.jpg",
    originalTitle: "",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_106.jpg",
    thumbnail: "../../../photo_106.jpg",
    originalTitle: "15.09.2025г.",
  },
  {
    // originalHeight: 500,
    // originalWidth: 700,
    thumbnailHeight: 70,
    thumbnailWidth: 300,
    original: "../../../photo_107.jpg",
    thumbnail: "../../../photo_107.jpg",
    originalTitle: "",
  },
];
